import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=5b0d5610&"
import script from "./Function.vue?vue&type=script&lang=js&"
export * from "./Function.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports